export const drmtFilterPayload = {
  division: "",
  originCountry: [],
  destinationCountry: [],
  filters: {
    carrierScac: [],
    serviceScac: [],
    tariffNumber: [],
    tariffId: [],
    orgHub: [],
    originZone: [],
    originZoneDesc: [],
    originZoneShortDesc: [],
    originCity: [],
    originState: [],
    originCountry: [],
    destHub: [],
    destinationZone: [],
    destinationZoneDesc: [],
    destinationZoneShortDesc: [],
    destinationCity: [],
    destinationState: [],
    destinationCountry: [],
    region: [],
    carrierManager: [],
    miles: { params: [], operator: "", },
    laneServiceType: [],
    primaryCustomers: [],
    preAwarded: [],
    equipmentType: [],
    laneDescription: [],
    lineHaulChargeType: [],
    lineHaulRate: { params: [], operator: "" },
    rate: { params: [], operator: "" },
    awardBackup: [],
    effectiveDate: { date: [], operator:"" },
    expirationDate: { date: [], operator:"" },
    bucketType: [],
    qtyActiveFlag: [],
    qtyStartDate: { date: [], operator:"" },
    qtyEndDate: { date: [], operator:"" },
    minShipmentsAllocated: { params: [], operator: "" },
    maxShipmentsAllocated: { params: [], operator: "" },
    percentageActiveFlag: [],
    pctStartDate: { date: [], operator:"" },
    pctEndDate: { date: [], operator:"" },
    minCarrierAllocationPercentage: { params: [], operator: "" },
    maxCarrierAllocationPercentage: { params: [], operator: "" },
    modeOfTransport: [],
    status: [],
    bidFileName: [],
    defaultError: [],
    userId: [],
    createdDate: { date: [], operator: "" },
    updatedDate: { date: [], operator: "" },
    changeComment: [],
  },
};
